import { useLocation } from "react-router";

// import style
import "../../style/pages/layout/footer.scss";

const FooterB = () => {
  const location = useLocation();

  return (
    <div className="footerb-section">
      <div
        className={`sub-section-a ${
          location.pathname === "/"
            ? "background-green-a"
            : location.pathname === "/about"
            ? "background-green-a"
            : location.pathname === "/articles"
            ? "background-orange-a"
            : location.pathname === "/classes"
            ? "background-pink-a"
            : location.pathname === "/shop"
            ? "background-blue-a"
            : location.pathname === "/videos"
            ? "background-purple-a"
            : location.pathname === "/register"
            ? "background-red-a"
            : location.pathname === "/question"
            ? "background-black-a"
            : "background-green-a"
        }`}
      ></div>
      <div
        className={`sub-section-b ${
          location.pathname === "/"
            ? "background-green-b"
            : location.pathname === "/about"
            ? "background-green-b"
            : location.pathname === "/articles"
            ? "background-orange-b"
            : location.pathname === "/classes"
            ? "background-pink-b"
            : location.pathname === "/shop"
            ? "background-blue-b"
            : location.pathname === "/videos"
            ? "background-purple-b"
            : location.pathname === "/register"
            ? "background-red-b"
            : location.pathname === "/question"
            ? "background-black-b"
            : "background-green-b"
        }`}
      ></div>
      <div
        className={`sub-section-c ${
          location.pathname === "/"
            ? "background-green-c"
            : location.pathname === "/about"
            ? "background-green-c"
            : location.pathname === "/articles"
            ? "background-orange-c"
            : location.pathname === "/classes"
            ? "background-pink-c"
            : location.pathname === "/shop"
            ? "background-blue-c"
            : location.pathname === "/videos"
            ? "background-purple-c"
            : location.pathname === "/register"
            ? "background-red-c"
            : location.pathname === "/question"
            ? "background-black-c"
            : "background-green-c"
        }`}
      ></div>
      <div
        className={`sub-section-d ${
          location.pathname === "/"
            ? "background-green-d"
            : location.pathname === "/about"
            ? "background-green-e"
            : location.pathname === "/articles"
            ? "background-orange-d"
            : location.pathname === "/classes"
            ? "background-pink-d"
            : location.pathname === "/shop"
            ? "background-blue-d"
            : location.pathname === "/videos"
            ? "background-purple-d"
            : location.pathname === "/register"
            ? "background-red-d"
            : location.pathname === "/question"
            ? "background-black-d"
            : "background-green-d"
        }`}
      ></div>
    </div>
  );
};

export default FooterB;
